const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent);

const isIOSDevice = () =>
  /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const HOME_HERO_IMAGE_READY_EVENT = 'home-hero-image-ready';
let isHomeHeroImageReady = false;

const markHomeHeroImageReady = () => {
  isHomeHeroImageReady = true;
  window.dispatchEvent(new Event(HOME_HERO_IMAGE_READY_EVENT));
};

const resetHomeHeroImageReady = () => {
  isHomeHeroImageReady = false;
};

const getIsHomeHeroImageReady = () => isHomeHeroImageReady;

export {
  isMobileDevice,
  isIOSDevice,
  HOME_HERO_IMAGE_READY_EVENT,
  markHomeHeroImageReady,
  resetHomeHeroImageReady,
  getIsHomeHeroImageReady,
};
